import React, { useEffect } from "react";
import styled from "styled-components";

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background: linear-gradient(135deg, rgb(38, 67, 91) 0%, rgb(71, 38, 0) 100%);

  #particles-js {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;

// Warm off-white to match the brand glow
const PARTICLE_COLOR = "#636669";

// particles.js config — based on Vincent Garreau's demo
// https://codepen.io/VincentGarreau/pen/bGxvQd
const config = {
  particles: {
    number: { value: 80, density: { enable: true, value_area: 800 } },
    color: { value: PARTICLE_COLOR },
    shape: {
      type: "circle",
      stroke: { width: 0, color: "#000000" },
      polygon: { nb_sides: 5 },
    },
    opacity: {
      value: 0.5,
      random: false,
      anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false },
    },
    size: {
      value: 3,
      random: true,
      anim: { enable: false, speed: 40, size_min: 0.1, sync: false },
    },
    line_linked: {
      enable: true,
      distance: 150,
      color: PARTICLE_COLOR,
      opacity: 0.4,
      width: 1,
    },
    move: {
      enable: true,
      speed: 1,
      direction: "none",
      random: false,
      straight: false,
      out_mode: "out",
      bounce: false,
      attract: { enable: false, rotateX: 600, rotateY: 1200 },
    },
  },
  interactivity: {
    detect_on: "canvas",
    events: {
      onhover: { enable: true, mode: "grab" },
      onclick: { enable: true, mode: "push" },
      resize: true,
    },
    modes: {
      grab: { distance: 140, line_linked: { opacity: 1 } },
      bubble: { distance: 400, size: 40, duration: 2, opacity: 8, speed: 3 },
      repulse: { distance: 200, duration: 0.4 },
      push: { particles_nb: 4 },
      remove: { particles_nb: 2 },
    },
  },
  retina_detect: true,
};

const AnimatedBackground = () => {
  useEffect(() => {
    let cancelled = false;

    // particles.js attaches itself to `window` on import, so load it
    // client-side only to avoid touching `window` during SSR.
    import("particles.js").then(() => {
      if (cancelled || !window.particlesJS) return;
      window.particlesJS("particles-js", config);
    });

    return () => {
      cancelled = true;
      if (window.pJSDom && window.pJSDom.length) {
        window.pJSDom.forEach((dom) => dom.pJS.fn.vendors.destroypJS());
        window.pJSDom = [];
      }
    };
  }, []);

  return (
    <Background>
      <div id="particles-js" />
    </Background>
  );
};

export default AnimatedBackground;
